import SchemePopupLayout from "./SchemePopupLayout";

const TermLoanSchemePopup = ({ onClose }) => {
  return (
    <SchemePopupLayout
      title="Term Loan Scheme"
      intro="The Term Loan Scheme supports eligible minority entrepreneurs with financial assistance for setting up, expanding, or modernizing income-generating business and service activities."
      eligibility={[
        "Applicant must belong to a notified minority community.",
        "Annual family income should fall within NMDFC income limits.",
        "Applicant should propose a viable income-generating business activity.",
        "Must satisfy age, citizenship, and agency-level verification requirements.",
      ]}
      documents={[
        "Aadhaar Card / Identity Proof",
        "Address Proof",
        "Income Certificate",
        "Minority Community Certificate",
        "Project Report",
        "Bank Account Details",
        "Quotation / Cost Estimate",
        "Passport-size Photograph",
      ]}
      applyLabel="Apply for Term Loan Scheme"
      videoUrl="https://www.youtube.com/embed/-mSg97uhdSM"
      onClose={onClose}
    />
  );
};

export default TermLoanSchemePopup;
